import { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faApple, faGoogle, faAmazon, faChrome, faSafari, faFirefox } from '@fortawesome/free-brands-svg-icons';
import ipadMobileMags from './images/ipad-mobile-mags.png';
import icon1 from './images/icons/icon-1.png';
import icon2 from './images/icons/icon-2.png';
import icon3 from './images/icons/icon-3.png';
import icon4 from './images/icons/icon-4.png';
import icon5 from './images/icons/icon-5.png';

export default function FeaturesPanel() {
  return (
    <div className="py-5 md:py-16">
      <Container className="flex flex-col items-center justify-center">
        <div className="grid grid-cols-2">
          <div className="order-last md:order-first col-span-2 md:col-span-1 px-10 md:px-28 flex flex-col items-center py-5">
            <img src={ipadMobileMags} alt="Digital magazines on tablet and mobile device" />
            <div className="flex items-center justify-center mt-5">
              <div className="px-5 py-3 rounded-full bg-slate-100 flex items-center justify-center text-slate-700">
                <FontAwesomeIcon icon={faApple} className="mr-4 text-2xl" />
                <FontAwesomeIcon icon={faGoogle} className="mr-4 text-2xl" />
                <FontAwesomeIcon icon={faAmazon} className="mr-4 text-2xl" />
                <FontAwesomeIcon icon={faChrome} className="mr-4 text-2xl" />
                <FontAwesomeIcon icon={faSafari} className="mr-4 text-2xl" />
                <FontAwesomeIcon icon={faFirefox} className="text-2xl" />
              </div>
            </div>
          </div>
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-center md:text-left text-2xl md:text-3xl font-bold mb-4">
              Plunge into the world of Unlimited Reading
              <br className="hidden lg:inline-block" /> right away
            </h3>
            <IconFeature image={icon1} feature="Read 10,000+ best-selling magazines and newspapers" />
            <IconFeature image={icon2} feature="Access premium stories and newspapers" />
            <IconFeature image={icon3} feature="Download to read offline" />
            <IconFeature image={icon4} feature="Cancel anytime (no commitments)" />
            <IconFeature image={icon5} feature="Digital only, access on all devices" />
          </div>
        </div>
      </Container>
    </div>
  );
}

type IconFeatureProps = {
  image: string;
  feature: ReactNode;
};

// The icons carry no meaning the sentence beside them does not already carry, so they
// are decorative and take an empty alt rather than repeating it to a screen reader.
function IconFeature({ image, feature }: IconFeatureProps) {
  return (
    <div className="items-center py-3 mb-1 grid grid-cols-8">
      <div className="col-span-2 md:col-span-1">
        <img src={image} width={75} height={75} alt="" />
      </div>
      <span className="col-span-6 md:col-span-7 text-lg font-medium ml-3">{feature}</span>
    </div>
  );
}
